import { Box, SxProps, Theme, Typography } from "@mui/material";

type TextDescriptionProps = {
  title: string;
  value?: string | null;
  boxSx?: SxProps<Theme>;
  titleSx?: SxProps<Theme>;
  valueSx?: SxProps<Theme>;
};

export default function TextDescription({
  title,
  value,
  boxSx,
  titleSx,
  valueSx,
}: TextDescriptionProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        ...boxSx,
        marginRight: { xs: "8px", sm: "21px" },
      }}
    >
      <Typography
        sx={{
          fontWeight: "500",
          fontSize: { xs: "13px", sm: "16px" },
          ...titleSx,
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          paddingLeft: "8px",
          fontSize: { xs: "12px", sm: "15px" },
          ...valueSx,
        }}
      >
        {value ?? "Não Informado"}
      </Typography>
    </Box>
  );
}
